/**
 * Leveranciers (main, 23 okt 2026) — overzicht van freelancers en bedrijven voor PL en
 * management. Alleen lezen: bewerken en toevoegen gebeurt voorlopig in Airtable. De bron is
 * de Leveranciers-base (live gelezen door de engine), aangevuld met inzet uit draaidagen,
 * taken en Gripp-uren. Op develop staan hier ook de HR-tabbladen (overeenkomsten,
 * datacorrecties, beoordelingen); die komen mee met de develop-release.
 */
import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../../ui-components/PageHeader';
import LeveranciersOverzicht from './LeveranciersOverzicht';

export default function Leveranciers() {
  return (
    <Box sx={{ width: '100%', maxWidth: 1800, mx: 'auto', px: { xs: 2, sm: 3, md: 5 }, pt: { xs: 3, md: 5 }, pb: 6 }}>
      <PageHeader
        icon="handshake"
        title="Leveranciers"
        subtitle="Freelancers en bedrijven waar we mee werken — contact, tarieven, beoordelingen en inzet"
        accent={{ color: '#526075', bg: '#d5e3fd' }}
      />
      <LeveranciersOverzicht />
    </Box>
  );
}
